/*
 * @providesModule TelemetryConstants
 */

import * as AWSConstants from 'AWSConstants';

/**
 * @deprecated Legacy AWS constants - use TelemetryEventName enum instead
 * These constants are imported for backward compatibility only.
 * Please migrate to the new TelemetryEventName enum.
 */
export const DeprecatedAWSConstants = {
  ...AWSConstants,
} as const;

/**
 * Telemetry event names for tracking user interactions.
 *
 * IMPORTANT: Event name character limits:
 * - AWS Pinpoint: Maximum 50 characters
 * - CleverTap: Maximum 120 characters
 *
 * Please ensure all new event names comply with these limits.
 */
export enum TelemetryEventName {
  LEAGUES_PAGE_LOAD = 'leagues_page_load',
  STORE_PAGE_LOAD = 'store_page_load',
  MENU_PAGE_LOAD = 'menu_page_load',
  LOBBY_PLAY_TAB_CLICK = 'lobby_play_tab_click',
  LOBBY_WALLET_ICON_CLICK = 'lobby_wallet_icon_click',
  TRANSACTIONS_PAGE_LOAD = 'transactions_page_load',
  WITHDRAW_STANDARD_PAGE_LOAD = 'withdraw_standard_page_load',
  WITHDRAW_LANDING_PAGE_LOAD = 'withdraw_landing_page_load',
  WITHDRAW_CONFIRM_POPUP_CTA_CLICK = 'withdraw_confirm_popup_cta_click',
  WITHDRAW_SUCCESS_SHOWN = 'withdraw_success_shown',
  TROPHIES_PAGE_LOAD = 'trophies_page_load',
  SKILLZ_NEWS_PAGE_LOAD = 'skillz_news_page_load',
  SKILLZ_NEWS_PAGE_CTA_CLICK = 'skillz_news_page_cta_click',
  CHAT_PAGE_LOAD = 'chat_page_load',
  REFERRAL_PAGE_LOAD = 'referral_page_load',
  LEAGUE_REWARD_CLAIM = 'league_reward_claim',
  INTERSTITIAL_SHOWN = 'interstitial_shown_skillz',
  INTERSTITIAL_CTA_CLICK = 'interstitial_cta_click',
  INTERSTITIAL_TILE_CLICK = 'interstitial_tile_click',
  INTERSTITIAL_TILE_SHOWN = 'interstitial_tile_shown',
  LOBBY_PLAY_BUTTON_CLICK = 'lobby_play_button_click',
  TICKETZ_STORE_LOAD = 'ticketz_store_load',
  DAILY_CHALLENGE_LOAD = 'daily_challenge_load',
  LOBBY_SECTION_EXPAND_CLICK = 'lobby_section_expand_click',
  EVENT_DETAILS_PAGE_CTA_CLICK = 'event_details_page_cta_click',
  VS_PAGE_LOAD = 'vs_page_load',
  RESULT_SCREEN_LOAD = 'result_screen_load',
  RESULT_SCREEN_CTA_CLICK = 'result_screen_cta_click',
  STORE_PAGE_DEPOSIT_SLATE_CLICK = 'store_page_deposit_slate_click',
  STORE_PAGE_CTA_CLICK = 'store_page_cta_click',
  STORE_PAGE_CTA_CLICK_WEB = 'store_page_cta_click_web',
  STORE_PAGE_ENTER_PROMO_CODE_PAGE_DONE_CLICK = 'store_page_enter_promo_code_page_done_click',
  STORE_CHECKOUT_PAGE_LOAD = 'store_checkout_page_load',
  STORE_CHECKOUT_PAGE_SUBMIT_CLICK = 'store_checkout_page_submit_click',
  STORE_CHECKOUT_DEPOSIT_CANCELLED = 'store_checkout_deposit_cancelled',
  STORE_CHECKOUT_BANK_PROMO_CLICKED = 'store_checkout_bank_promo_clicked',
  PAYMENT_SUCCESS = 'payment_success',
  STORE_V2_PAYMENT_PAGE_LOAD = 'store_v2_payment_page_load',
  STORE_V2_PAYMENT_PAGE_SUBMIT_CLICK = 'store_v2_payment_page_submit_click',
  STORE_V2_PAYMENT_PAGE_PAYMENT_METHOD_SUBMIT = 'store_v2_payment_page_payment_method_submit',
  STORE_V2_PAYMENT_PAGE_EXIT = 'store_v2_payment_page_exit',
  AEROPAY_AEROSYNC_EVENT = 'aeropay_aerosync_event',
  REFERRAL_PAGE_CTA_CLICK = 'referral_page_cta_click',
  WITHDRAW_STANDARD_PAGE_CTA_CLICK = 'withdraw_standard_page_cta_click',
  LEAGUE_PAGE_CTA_CLICK = 'league_page_cta_click',
  LEAUE_INFO_MODAL = 'league_info_modal',
  PAID_LEAGUE_OPT_IN_BUTTON_CLICK = 'paid_league_opt_in_button_click',
  PAID_LEAGUE_OPT_OUT_CLICK = 'paid_league_opt_out_click',
  PAID_LEAGUE_OPT_OUT_CONFIRM = 'paid_league_opt_out_confirm',
  MENU_PAGE_CTA_CLICK = 'menu_page_cta_click',
  PLAYER_PROFILE_PAGE_LOAD = 'player_profile_page_load',
  HISTORY_PAGE_CTA_CLICK = 'history_page_cta_click',
  SKILLZ_REWARDZ_PAGE_LOAD = 'skillz_rewardz_page_load',
  MERGE_ACCOUNT = 'merge_account',
  LOGOUT_CLICK = 'logout_click',
  TROPHY_CLAIMED = 'trophy_claimed',
  DAILY_CHALLENGE_LOBBY_CTA_CLICKED = 'daily_challenge_lobby_cta_clicked',
  DAILY_CHALLENGE_MODAL_CTA_CLICK = 'daily_challenge_modal_cta_click',
  DAILY_CHALLENGES_REWARD_CLAIM = 'daily_challenges_reward_claim',
  SIGN_UP_PAGE_LOAD = 'sign_up_page_load',
  SIGN_UP_CTA_CLICK = 'sign_up_cta_click',
  SIGN_UP_SUCCESS = 'sign_up_success',
  SIGN_IN_PAGE_LOAD = 'sign_in_page_load',
  LOBBY_LOAD = 'lobby_load',
  SIGN_IN_CTA_CLICK = 'sign_in_cta_click',
  SIGN_IN_SUCCESS = 'sign_in_success',
  SKILLZ_INITIALISATION_LOAD_START = 'skillz_initialisation_load_start',
  // Live Bracket Events
  LIVE_BRACKET_ICON_HOME_CLICK = 'live_bracket_icon_home_click',
  LIVEBRACKETS_REGISTER_TAP = 'livebrackets_register_tap',
  LIVE_BRACKET_ADD_CALENDAR_TAP = 'live_bracket_add_calendar_tap',
  LIVE_BRACKET_CALENDAR_PERMISSION_CHECK = 'live_bracket_calendar_permission_check',
  LIVE_BRACKET_EVENTS_PAGE = 'live_bracket_events_page',
  LIVE_BRACKET_EXIT_ICON_CLICK = 'live_bracket_exit_icon_click',
  LIVE_BRACKET_GAME_PLAY_END = 'live_bracket_game_play_end',
  LIVE_BRACKET_MATCH_TAPPED = 'live_bracket_match_tapped',
  LIVE_BRACKET_NOTIFICATION_CHECK = 'live_bracket_notification_check',
  LIVE_BRACKET_NOTIFY_CLICK = 'live_bracket_notify_click',
  LIVE_BRACKET_NOTIFY_SUCCESS = 'live_bracket_notify_success',
  LIVE_BRACKET_PUSH_NOTIF_GRANTED = 'live_bracket_push_notif_granted',
  LIVE_BRACKET_RESULT_SCREEN = 'live_bracket_result_screen',
  LIVE_BRACKET_ROUND_TAB_CLICKED = 'live_bracket_round_tab_clicked',
  LIVE_BRACKET_RULES_CLICKED = 'live_bracket_rules_clicked',
  LIVE_BRACKET_WELCOME_POPUP = 'live_bracket_welcome_popup',
  LIVE_BRACKET_WELCOME_SCREEN_CLICK = 'live_bracket_welcome_screen_click',
  LIVE_BRACKET_BOTTOMSHEET_VIEW_BRACKET_CLICK = 'live_bracket_bottomsheet_view_bracket_click',
  LIVE_BRACKET_BOTTOMSHEET_VIEW_ICON_CLICK = 'live_bracket_bottomsheet_view_icon_click',
  LIVE_BRACKET_GAME_PLAY_BEGIN = 'live_bracket_game_play_begin',
  LIVE_BRACKET_TEMPLATE_AVAILABLE = 'live_bracket_template_available',
  LIVE_BRACKET_BOTTOMSHEET_HOME = 'live_bracket_bottomsheet_home',
  LIVE_BRACKET_LOCATION_CHECK = 'live_bracket_location_check',
  LIVE_BRACKET_REGISTER_RESULT = 'live_bracket_register_result',
  SIGNIN_PAGE_RESEND_OTP_CLICKED = 'signin_page_resend_otp_clicked',
  FTUE_PATH_SELECTION = 'ftue_path_selection',
  SIGNIN_PAGE_CALL_ME_INSTEAD = 'signin_page_call_me_clicked',
  LOBBY_EMAIL_VERIFY_CLICKED = 'lobby_email_verify_clicked',
  EMAIL_VERIFY_SUCCESS = 'email_verify_success',
  MENU_ACCOUNT_MERGE_ATTEMPTS = 'menu_account_merge_attempt',
  FTUE_PAGE_LOADED = 'ftue_page_loaded',
  MAINTENANCE_POPUP_SHOWN = 'maintenance_popup_shown',
  MAINTENANCE_POPUP_HIDE = 'maintenance_popup_hide',
  LOBBY_FIRST_CASH_CLICKED = 'lobby_first_cash_clicked',
  LOBBY_NEW_USER_TEMPLATE_CLICKED = 'lobby_new_user_template_clicked',
  FIRST_PRACTICE_GAME_CTA_CLICKED = 'first_practice_game_cta_clicked',
  WITHDRAW_OPTIONS_SCREEN_LOAD = 'withdraw_options_screen_load',
  WITHDRAW_OPTIONS_SELECTION_CLICKED = 'withdraw_options_selection_clicked',
  LIVE_BRACKET_STRIP_DISMISSED = 'live_bracket_strip_dismissed',
  LOBBY_REFERRAL_ICON_CLICK = 'lobby_icon_click',
  PROMOTIONAL_BANNER_SEEN = 'promotional_banner_seen',
  PROMOTIONAL_BANNER_CLICK = 'promotional_banner_click',
  // Daily LTO events
  DAILY_BONUS_LTO_CALENDAR_VIEWED = 'daily_bonus_lto_calendar_viewed',
  DAILY_BONUS_LTO_CALENDAR_CLCIKED = 'daily_bonus_lto_calendar_clicked',
  LOBBY_Z_ICON_CLICK = 'lobby_z_icon_click',
  HISTORY_PAGE_LOAD = 'history_page_load',
  EVENT_DETAILS_PAGE_LOAD = 'event_details_page_load',
  BRACKET_DETAILS_PAGE_LOAD = 'bracket_details_page_load',
  BRACKET_DETAILS_PAGE_CTA_CLICK = 'bracket_details_page_cta_click',
  LOBBY_ENTER_MATCH_CODE_SUBMIT = 'lobby_enter_match_code_submit',
  TROPHY_PAGE_CTA_CLICK = 'trophy_page_cta_click',
  TICKETZ_STORE_PAGE_LOAD = 'ticketz_store_page_load',
  TICKETZ_STORE_ITEM_CLICK = 'ticketz_store_item_click',
  CHAT_MESSAGE_SEND_CLICK = 'chat_message_send_click ',
  LOBYY_ENTER_MATCH_CODE_SUBMIT = 'lobby_enter_match_code_submit',
  VS_PAGE_MATCH_DETAILS_PAGE_CTA_CLICK = 'vs_page_match_details_page_cta_click',
  VS_PAGE_CTA_CLICK = 'vs_page_cta_click',
  MY_ACCOUNT_PAGE_LOAD = 'my_account_page_load',
  MY_ACCOUNT_PAGE_CTA_CLICK = 'my_account_page_cta_click',
  STORE_V2_PAYMENT_PAGE_PAYPAL_SUBMIT_CLICK = 'store_v2_payment_page_paypal_submit_click',
  STORE_V2_PAYMENT_PAGE_BANK_SECURITY_ICON_CLICKED = 'store_v2_payment_page_bank_security_icon_clicked',
  PAID_LEAGUE_OPT_IN_MODAL_SHOWN_AUTOMATIC = 'paid_league_opt_in_modal_shown_automatic',
  PAID_LEAGUE_OPT_IN_MODAL_JOIN_CLICK = 'paid_league_opt_in_modal_join_click',
  PAID_LEAGUE_OPT_IN_MODAL_DISMISSED = 'paid_league_opt_in_modal_dismissed',
  PLAYER_PROFILE_MODAL_LOAD = 'player_profile_modal_load',
  PLAYER_PROFILE_MODAL_CTA_CLICK = 'player_profile_modal_cta_click',
  PLAYER_PROFILE_MODAL_HAMBURGER_CTA_CLICK = 'player_profile_modal_hamburger_cta_click',
  PLAYER_PROFILE_PAGE_CTA_CLICK = 'player_profile_page_cta_click',
  REAL_TIME_MATCHES_SELECTION_SCREEN_LOAD = 'real_time_matches_selection_screen_load',
  REAL_TIME_MATCHES_FIND_OPPONENT_CLICK = 'real_time_matches_find_opponent_click',
  REAL_TIME_MATCHES_FINDING_SCREEN_LOAD = 'real_time_matches_finding_screen_load',
  REAL_TIME_MATCHES_FINDING_SCREEN_CTA_CLICK = 'real_time_matches_finding_screen_cta_click',
  REAL_TIME_MATCHES_MATCH_FOUND_LOAD = 'real_time_matches_match_found_load',
  REAL_TIME_MATCHES_MATCH_FOUND_CTA_CLICK = 'real_time_matches_match_found_cta_click',
  REAL_TIME_MATCHES_MATCH_FOUND_ACCEPT_CLICK = 'real_time_matches_match_found_accept_click',
  SIGN_IN_OTP_SCREEN_LOADED = 'sign_in_otp_screen_loaded',
  SIGN_IN_OTP_SCREEN_CALLME_CLICKED = 'sign_in_otp_screen_callme_clicked',
  STORE_PAGE_CAROUSEL_CLICKED = 'store_page_carousel_clicked',
  AGE_INPUT_SCREEN_LODED = 'age_input_screen_loaded',
  AGE_INPUT_SCREEN_CTA_CLICK = 'age_input_screen_cta_click',
  LEAGUE_VIEW_MILESTONE_REWARDS_MODAL = 'league_view_milestone_rewards_modal',
  LEAGUE_CLAIM_SINGLE_MILESTONE = 'league_claim_single_milestone',
  LEAGUE_CLAIM_ALL_MILESTONE = 'league_claim_all_milestones',
  LEAGUE_TAP_MILESTONE_REWARDS_INFO = 'league_tap_milestone_rewards_info',
  STORE_BANK_LINKING_ACCOUNT_INFO_PAGE_SHOWN = 'store_bank_linking_account_info_page_shown',
  STORE_BANK_LINKING_ACCOUNT_INFO_PAGE_SUBMIT_CLICK = 'store_bank_linking_account_info_page_submit_click',
  STORE_BANK_LINKING_COMPLETE = 'store_bank_linking_complete',
  STORE_BANK_LINKING_FAIL = 'store_bank_linking_fail',
  WITHDRAW_OPTIONS_SCREEN_POPUP_SHOW = 'withdraw_options_screen_popup_shown',
  WITHDRAW_BANK_PAGE_LOAD = 'withdraw_bank_page_load',
  WITHDRAW_BANK_PAGE_CTA_CLICK = 'withdraw_bank_page_cta_click',
  WITHDRAW_START_WITHDRAW_CLICK = 'withdraw_start_withdraw_click',
  WITHDRAW_VERIFY_PHONE_SHOWN = 'withdraw_verify_phone_shown',
  WITHDRAW_VERIFY_PHONE_CLICK = 'withdraw_verify_phone_click',
  EMAIL_INPUT_PAGE_CLICKED = 'email_input_page_clicked',
  ERROR_SCREEN_SHOWN = 'error_screen_shown',

  //FTUE 2.0 Events
  NFTUE_TNCS_POPUP_SEEN = 'nftue_tncs_popup_seen',
  NFTUE_TNCS_POPUP_CLICKED = 'nftue_tncs_popup_clicked',
  NFTUE_UNIFIED_LOGIN_CTA_CLICKED = 'nftue_unified_login_cta_clicked',
  NFTUE_MOBILE_SIGNIN_CTA_CLICKED = 'nftue_mobile_signin_cta_clicked',
  NFTUE_OTP_PAGE_CTA_CLICKED = 'nftue_otp_page_cta_clicked',
  NFTUE_EMAIL_PAGE_CTA_CLICKED = 'nftue_email_page_cta_clicked',
}
